// extracted by mini-css-extract-plugin
export default {"container":"Container_container__0ybur","fluid":"Container_fluid__OxbJr","bg":"Container_bg__EI8kx"};